////////////////////////////////////////
// IMPORTING MODULES
////////////////////////////////////////
import { useLocation, Link } from "react-router-dom";
import { Home, ArrowLeft, Plane } from "lucide-react";

////////////////////////////////////////
// COMPONENT: NOTFOUND
////////////////////////////////////////
const NotFound = (): JSX.Element => {
  const location = useLocation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0e1220] p-9">
      <div className="max-w-md w-full">
        <div className="bg-[#1a1f2e]/60 backdrop-blur-sm border border-[#2ab8ff]/20 rounded-xl shadow-lg p-8 sm:p-10 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#2ab8ff]/10 rounded-full mb-6">
            <Plane className="h-8 w-8 text-[#2ab8ff]" />
          </div>
          <h1 className="text-7xl font-bold text-white mb-4">404</h1>
          <h2 className="text-xl font-semibold text-white mb-2">
            Page Not Found
          </h2>
          <p className="text-gray-300 text-sm mb-8">
            Looks like this flight got redirected. The page you're looking for
            doesn't exist.
          </p>
          <div className="bg-[#0e1220] border border-gray-700 rounded-lg p-3 mb-8">
            <p className="text-xs text-gray-400 font-mono break-all">
              {location.pathname}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="px-8 py-2 bg-[#2ab8ff] text-[#0e1220] rounded-lg hover:shadow-lg hover:shadow-[#2ab8ff]/30 font-semibold text-lg flex items-center justify-center gap-2 whitespace-nowrap transition-all"
            >
              <Home className="h-4 w-4" />
              <span>Go Home</span>
            </Link>
            <button
              onClick={() => window.history.back()}
              className="px-8 py-2 bg-[#0e1220] border border-gray-700 text-white rounded-lg hover:bg-[#1a1f2e] hover:shadow-lg font-semibold text-lg flex items-center justify-center gap-2 whitespace-nowrap transition-all"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Go Back</span>
            </button>
          </div>
        </div>
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-400 mb-3">
            Need help? Try these pages:
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            <Link
              to="/#contact"
              className="text-xs px-3 py-1.5 rounded-full bg-[#1a1f2e]/60 hover:bg-[#1a1f2e] border border-[#2ab8ff]/20 text-white transition-colors"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

////////////////////////////////////////
// EXPORTING NOTFOUND
////////////////////////////////////////
export default NotFound;
